import CreateItemButton from "components/buttons/create";
import List from "components/list";
import { PermissionControlledInput } from "permissions/components/input";
import HeaderPortal from "components/portal/header-portal";
import { StatusCell } from "@/components/status/cell";

export default function FunctionsList() {

    const columns = [
        {
            id: "name",
            header: "Name",
            accessorKey: "name",
            sortable: true,
        },
        {
            id: "status",
            header: "Status",
            accessorKey: "status",
            cell: StatusCell,
        },
    ];

    const fields = ["id", "name", "status"];


    return (
        <div className="w-full">
            <HeaderPortal>
                <PermissionControlledInput
                    rule={"create:*"}
                    collection="functions"
                    showWhenDisabled={false}
                >
                    <CreateItemButton href>Functions</CreateItemButton>
                </PermissionControlledInput>
            </HeaderPortal>
            <div className="flex-1 h-full">
                <List
                    title="Functions"
                    endPoint="functions"
                    columns={columns}
                    meta={{
                        fields,
                    }}
                    sortBy="name"
                    sortOrder="aesc"
                    href={(item) => item.id}
                    rowClassName="h-13"
                />
            </div>
        </div>
    );
}
